import { render } from "./ExchangeBox.vue?vue&type=template&id=18ad64ee"
import script from "./ExchangeBox.vue?vue&type=script&lang=js"
export * from "./ExchangeBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__